module.exports = require("@graphistry/falcor-path-utils/lib/toCollapseMap");


//////////////////
// WEBPACK FOOTER
// external "@graphistry/falcor-path-utils/lib/toCollapseMap"
// module id = 102
// module chunks = 0